module.exports = __webpack_public_path__ + "static/scale-model-of-fiske-planetarium-in-boulder-colorado-c4db4fcbd2a7cc185fa47107ace6dd94.png";